import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';

@customElement('svg-optics')
export class SvgOptics extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;
	  }

	  svg {
		height: 100%;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.status = state.status;
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-optic.svg';
		let housingType = getValueOfFeature('HS_HousingType', this.decisions);
		if (housingType === 'WallSurface') {
			housingType = 'PoleLateral';
		}
		const moduleSize = getValueOfFeature('HS_ModuleCutoutSize_1', this.decisions) ?? 'M3';
		const housing = (housingType === 'Column' || housingType === 'Bollard') ? housingType : housingType + '_'+ moduleSize;

		let extra;
		switch (getValueOfFeature('HS_HousingType', this.decisions)) {
			case 'WallSurface':
			case 'WallRecessed':
				extra = 'Wall_extra';
				break;
			case 'PoleLateral':
				extra = 'PoleLateral_extra';
				break;
			case 'PoleTop':
				extra = 'PoleTop_extra';
				break;
			default:
				extra = false;
		}

		const reflectorColour = getValueOfFeature('LE_ReflectorColour_1', this.decisions) ?? 'Gold';
		const version = getValueOfFeature('LE_OpticalVersion_1', this.decisions) ?? 'Performance';
		const colourTemperature = getValueOfFeature('LE_ColourTemperature_1', this.decisions);
		const lightDistribution = getValueOfFeature('LE_LightDistribution_1', this.decisions);

		let offset = housingType === 'Bollard' ? -290 : 0;
		if (housingType !== 'Column' && housingType !== 'Bollard') {
			switch (moduleSize) {
				case 'M1':
					offset = 920;
					break;
				case 'M3':
				case 'M3F':
					offset = 757;
					break;
				case 'M6':
					offset = 482;
					break;
				case 'M12':
					offset = 30;
					break;
				default:
					offset = 0;
			}
		}
		offset = offset - 290;

		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2855" height="2855" viewBox="0 0 2855 2855">
				<title>line-optic</title>
				<defs>
					<linearGradient id="Gradient-0" x1="1.14943" y1="0.5" x2="209.743" y2="0.499934" gradientUnits="userSpaceOnUse">
						<stop offset="0" stop-color="#ffa768"/>
						<stop offset="0.51331" stop-color="#ffffff"/>
						<stop offset="1" stop-color="#75d6ff"/>
					</linearGradient>
					<radialGradient id="Gradient-1" cx="-0.16129" cy="0.500005" r="1.69355" fx="-0.16129" fy="0.500005" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 31 -31 0 43.0002 56.998)">
						<stop offset="0" stop-color="#d9d9d9"/>
						<stop offset="1" stop-color="#d9d9d9" stop-opacity="0"/>
					</radialGradient>
					<radialGradient id="Gradient-2" cx="-0.046875" cy="0.500135" r="1.35938" fx="-0.046875" fy="0.500135" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 32 -32 0 47.0043 53.498)">
						<stop offset="0" stop-color="#d9d9d9"/>
						<stop offset="1" stop-color="#d9d9d9" stop-opacity="0"/>
					</radialGradient>
					<radialGradient id="Gradient-3" cx="0.0833333" cy="0.500023" r="0.892857" fx="0.0833333" fy="0.500023" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 42 -42 0 57.001 48.498)">
						<stop offset="0" stop-color="#d9d9d9"/>
						<stop offset="1" stop-color="#d9d9d9" stop-opacity="0"/>
					</radialGradient>
				</defs>
				<g id="line-optic" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(1427.5,1550.56) translate(-1427.5,-1550.56)">
					<g id="Housing" transform="translate(867.5,1550.56) translate(-1427.5,-1550.56)">
									${when(extra, () => svg`<use href="${svgPath}#${extra}"></use>`)}
									<use href="${svgPath}#${housing}"></use>
					</g>
					<g id="Modules" transform="translate(867,1429) translate(-150,-1147)">
						<g id="Gold_M1_ComfortOptic" transform="translate(150,372) translate(-150,-91)">
								<use href="${svgPath}#${reflectorColour}_${moduleSize}_${version}" style="transform: translateY(${offset}px)"></use>
						</g>
					</g>
					<g id="ColourTemperature" transform="translate(2485,1427.5) scale(3.7,3.7) translate(-100,-14.18)">
            			<path id="Balken-Farbe" fill="url(#Gradient-0)" fill-rule="nonzero" d="M0,0L200,0L200,1L0,1Z" transform="translate(100,4.5) translate(-100,-0.5)"/>
						<use href="${svgPath}#ColourTemperature_${colourTemperature}"></use>
					</g>
					<g id="LightDistribution" transform="translate(1919.75,1393.53) scale(3.7,3.7) translate(-37.25,-51.9975)">
						<use href="${svgPath}#${lightDistribution}"></use>
						<g id="base" transform="translate(32,51.998) translate(-32,-32)">
							<ellipse id="ring" stroke="#606060" rx="32" ry="32" transform="translate(32,32)"/>
							<ellipse id="center" fill="#FFFFFF" fill-rule="nonzero" rx="2" ry="2" transform="translate(32.5,32.5)"/>
						</g>
					</g>
					<path id="line" d="M0,0L-409,0" stroke="#313131" fill="none" stroke-linecap="square" stroke-width="2" transform="translate(1653.5,1387.99)"/>
				</g>
			</svg>

		`;
	}
}
